import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import type { NotifyBannerProps } from "@/types/notify.types";
import { NOTIFY_VARIANT_TOKENS } from "./tokens";

export function Banner({
  variant,
  title,
  description,
  children,
  onDismiss,
  className,
}: NotifyBannerProps) {
  const spec = NOTIFY_VARIANT_TOKENS[variant];
  const Icon = spec.icon;
  return (
    <div
      role={spec.ariaRole}
      aria-live={spec.ariaLive}
      className={cn(
        "flex items-start gap-2 rounded-md border p-3",
        spec.bgClass,
        spec.borderClass,
        spec.textClass,
        className
      )}
    >
      <Icon className={cn("mt-0.5 h-4 w-4 shrink-0", spec.accentClass)} aria-hidden="true" />
      <div className="min-w-0 flex-1">
        {title ? <div className="text-sm font-medium">{title}</div> : null}
        {children ? (
          <div className="mt-0.5 text-xs">{children}</div>
        ) : description ? (
          <div className="mt-0.5 text-xs text-text-secondary">{description}</div>
        ) : null}
      </div>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Fechar"
          className={cn("text-text-tertiary hover:opacity-80", spec.accentClass)}
        >
          <X size={14} />
        </button>
      ) : null}
    </div>
  );
}
